<button type="button"
  class="flex rtl:flex-row-reverse bg-orange items-center text-white font-semibold uppercase rounded-full pl-9 pr-6 py-3 w-max transition delay-75 duration-200 hover:scale-110"
  [routerLink]="link">
  <span [transloco]="'btn-vn.' + text"></span>
  <img src="/images/icons/arrow-icon.svg" alt="white arrow" class="mx-2 pb-1 w-[2rem] h-fit animate-bounce-right">
</button>